import { render, staticRenderFns } from "./SupplierControl.vue?vue&type=template&id=0e4171fc&scoped=true&"
import script from "./SupplierControl.vue?vue&type=script&lang=js&"
export * from "./SupplierControl.vue?vue&type=script&lang=js&"
import style0 from "./SupplierControl.vue?vue&type=style&index=0&id=0e4171fc&scoped=true&lang=scss&"
import style1 from "./SupplierControl.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4171fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VDialog,VPagination})
